import * as React from 'react';
import { ArticleHeading3, ArticleParagraph1 } from '@cian/ui-kit';

import { FilePreviewImage } from '../FilePreviewImage/FilePreviewImage';
import { IFileFieldValue } from '../../../../types/file';

import * as styles from './styles.css';

export interface IFileViewProps {
  value: IFileFieldValue;

  onDelete(): void;
}

export const FileView: React.FC<IFileViewProps> = props => {
  const { value, onDelete } = props;

  return (
    <div className={styles['container']} data-testid="file-preview">
      <div className={styles['preview']}>
        <FilePreviewImage />
      </div>
      <div className={styles['content']}>
        <ArticleHeading3>{value.name}</ArticleHeading3>
        <div className={styles['description']}>
          <ArticleParagraph1 color="black_60">{value.size}</ArticleParagraph1>
          <div className={styles['action']} onClick={onDelete} data-testid="file-preview-delete">
            <ArticleParagraph1 color="primary_100">Удалить документ</ArticleParagraph1>
          </div>
        </div>
      </div>
    </div>
  );
};

FileView.displayName = 'FileView';
